

import Unipage from "../templates/Unipage";

export default function Contact(props) {

	document.title = "Contact - Img2pdf";

	return (
		<Unipage
			content={
				<>
					<h1>Contact Img2pdf</h1>
					<div className="row m-0 p-0">
						<div className="col-12 p-0 mx-auto">
							<iframe src="https://docs.google.com/forms/d/e/1FAIpQLSePcpt7iXsRZRCyKaI8Mmy2bLsoAwgBiDo-w6_BVmXP7Kmr8g/viewform?embedded=true" width="750" height="1000" frameborder="0" marginheight="0" marginwidth="auto">Loading�</iframe>
						</div>
					</div>
				</>
			}
		/>
	);
}